/*
 * 「标签筛选」pill — 独立筛选项
 *
 * 两个状态：
 * - teamTagCount > 0：正常筛选，点击打开 TagPicker
 * - teamTagCount === 0：未设置团队标签，pill 上挂「✦ 限免」徽章，点击
 *   弹出 CTA popover 引导去管理弹窗设置（替代直接进 TagPicker）
 * - teamTagCount === null（未加载完）：按原有逻辑，无徽章无 CTA
 */
import React, { useState } from 'react'
import { Popover } from 'antd'
import ArrowIcon from '../icons/ArrowIcon'
import { FilterState } from '../../types'
import { formatNum } from '../../../../../utils/utils'

type TagFilterSelectorProps = {
  filter: FilterState
  count: number
  teamTagCount: number | null
  filteredPhotosNum: number
  isAdmin: boolean
  onOpen: () => void
  onSetupTags: () => void
}

const TagFilterSelector: React.FC<TagFilterSelectorProps> = ({
  count,
  teamTagCount,
  filteredPhotosNum,
  isAdmin,
  onOpen,
  onSetupTags
}) => {
  const isActive = count > 0
  const isEmpty = teamTagCount === 0
  const showFreeBadge = isEmpty && isAdmin
  const [popoverVisible, setPopoverVisible] = useState(false)

  const handleCtaClick = () => {
    setPopoverVisible(false)
    onSetupTags()
  }

  const pill = (
    <div
      className={`pfv2-selector pfv2-selector--tag ${
        isActive ? 'pfv2-selector--active' : ''
      } ${showFreeBadge ? 'pfv2-selector--tag-empty' : ''}`}
      onClick={isEmpty ? undefined : onOpen}
    >
      {showFreeBadge && (
        <span className="pfv2-selector__free-badge">✦ 限免</span>
      )}
      <div
        className={`pfv2-selector-value pfv2-selector-value--tag ${
          isActive ? 'pfv2-selector-value--active' : ''
        }`}
      >
        标签筛选
        {isActive && `(${count})`}
      </div>
      <ArrowIcon isActive={isActive} />
    </div>
  )

  if (!isEmpty) {
    return pill
  }

  // 空态：用 Popover 包一层，点击弹出 CTA；点击 CTA 时先关 popover 再开 modal
  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={popoverVisible}
      onOpenChange={setPopoverVisible}
      classNames={{ root: 'pfv2-tag-empty-popover' }}
      content={
        <div className="pfv2-tag-empty">
          <div className="pfv2-tag-empty__icon">📌</div>
          <div className="pfv2-tag-empty__title">还没有团队标签</div>
          <div className="pfv2-tag-empty__desc">
            设置后可按&quot;货架陈列 / 价签核对 / 促销物料&quot;
            <br />
            等场景秒筛 <b>{formatNum(filteredPhotosNum)}</b> 张照片
          </div>
          <button
            type="button"
            className="pfv2-tag-empty__cta"
            onClick={handleCtaClick}
          >
            立即设置标签
          </button>
        </div>
      }
    >
      {pill}
    </Popover>
  )
}

export default TagFilterSelector
